module.exports = __webpack_public_path__ + "img/tf.944f62cb.svg";